import { useFormContext, SubmitFormButton, RadioField } from '@calendly/form';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { FormFooter } from '../styles';
const formFieldsContainerCss = "fjzi50m";
const FormFieldsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(formFieldsContainerCss, props.className)} />;
});
export const FormContent = () => {
  const {
    handleReset
  } = useFormContext();
  return <>
      <FormFieldsContainer>
        <RadioField label={I18n.t('publisher.organization_settings.visibility.can_join')} name="available_to_request_to_join" value="true" />
        <RadioField label={I18n.t('publisher.organization_settings.visibility.cannot_join')} name="available_to_request_to_join" value="false" />
      </FormFieldsContainer>
      <FormFooter>
        <Button decoration="secondary-outline" onClick={handleReset}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <SubmitFormButton>
          {I18n.t('publisher.action.save')}
        </SubmitFormButton>
      </FormFooter>
    </>;
};

require("./form_content.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./form_content.js");